import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const Bullet = createIcon({
  displayName: 'Bullet',
  viewBox: '0 0 8 8',
  path: [
    <svg key="bullet">
      <circle cx="4" cy="4" r="4" />
    </svg>,
  ],
})
